import React from 'react';
import PropTypes from 'prop-types';
import BackButton from '../Buttons/BackButton';
import CloseButton from '../Buttons/CloseButton';

const ModalHeader = ({ title, onBackClick, onCloseClick }) => (
  <div className="modal-header">
    {onBackClick &&
      <BackButton onClick={onBackClick} />
    }

    <h2 className="modal-title">{title}</h2>
    <CloseButton onClick={onCloseClick} />
  </div>
);

ModalHeader.propTypes = {
  title: PropTypes.string,
  onBackClick: PropTypes.func,
  onCloseClick: PropTypes.func,
};

export default ModalHeader;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/ModalHeader.js